/**
 * 购物车抽屉优惠码模块
 * - 折叠/展开动画（与 footer 高度同步）
 * - Apply / 移除优惠码（/cart/update.js）
 * - Checkout 时把优惠码带到 /checkout?discount=
 */
(function () {
  'use strict';

  // 事件委托只绑定一次，避免购物车反复 rebuild 重复监听
  if (window.__cartDiscountBound) return;
  window.__cartDiscountBound = true;

  var pendingDiscountError = '';
  var DURATION = 300;
  var $ = window.jQuery;

  // 动画结束后清掉临时 height，交给正常文档流
  function sizeCartDrawerFooter() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer) return;
    footer.style.height = '';
  }

  // 应用/移除后刷新抽屉，重新渲染标签与价格
  function refreshCartDrawer() {
    var cartUrl = (window.routes && routes.cart_url) || '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var selectors = [
          'cart-drawer-items',
          '.cart-discount',
          '.cart-drawer__footer',
          '.cart-count-update span',
        ];

        selectors.forEach(function (selector) {
          var targetElement = document.querySelector(selector);
          var sourceElement = html.querySelector(selector);
          if (!targetElement || !sourceElement) return;

          if (selector === 'cart-drawer-items') {
            // 保留自定义元素实例，只替换内部 HTML
            targetElement.innerHTML = sourceElement.innerHTML;
            var hasItems = !!targetElement.querySelector('.cart-item');
            targetElement.classList.toggle('is-empty', !hasItems);
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) cartDrawer.classList.toggle('is-empty', !hasItems);
          } else {
            targetElement.replaceWith(sourceElement);
          }
        });

        restoreDiscountErrorMessage();
        sizeCartDrawerFooter();
      })
      .catch(function () {
        // section 拉取失败时回退到组件自带刷新
        var drawer = document.querySelector('cart-drawer-items');
        if (drawer && typeof drawer.onCartUpdate === 'function') {
          return drawer.onCartUpdate().then(restoreDiscountErrorMessage);
        }
      });
  }

  function getCheckoutButton() {
    return document.getElementById('CartDrawer-Checkout');
  }

  // Apply / 移除请求期间禁用 Checkout，并显示按钮 loading
  function setCheckoutLoading(isLoading) {
    var btn = getCheckoutButton();
    if (!btn) return;

    var spinner = btn.querySelector('.loading__spinner');
    if (isLoading) {
      btn.disabled = true;
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      if (spinner) spinner.classList.remove('hidden');
      return;
    }

    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
    if (spinner) spinner.classList.add('hidden');
    // 有商品才恢复可点；空车保持 disabled
    if (document.querySelector('#CartDrawer .cart-item')) {
      btn.disabled = false;
    }
  }

  // Apply / 移除链路期间禁用操作按钮；由外层在整段异步结束后解锁
  function setDiscountActionLoading(btn, isLoading) {
    if (!btn) return;
    if ($) $(btn).prop('disabled', !!isLoading);
    else btn.disabled = !!isLoading;
  }

  // 通过 Cart AJAX 写入折扣；传空字符串可清空。刷新抽屉由调用方决定。
  // 不在此处管理按钮禁用：单次 update 结束后调用方往往还有回滚 / refresh。
  function updateCartDiscount(discountValue) {
    var updateUrl = (window.routes && routes.cart_update_url) || '/cart/update.js';

    return fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ discount: discountValue }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Request failed');
          err.responseJSON = data;
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  // 仅 discount_code 类型视为可输入/可移除的优惠码
  function isRemovableDiscountCodeType(type) {
    var normalized = (type == null ? '' : type + '').toLowerCase();
    return normalized === 'discount_code' || normalized === '0';
  }

  function pushUniqueCode(codes, title) {
    title = ((title || '') + '').trim();
    if (!title) return;
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].toLowerCase() === title.toLowerCase()) return;
    }
    codes.push(title);
  }

  // 从 Cart AJAX 响应当中取出已实际分摊的优惠码（与橙色胶囊一致）
  function getAllocatedDiscountCodes(cart) {
    var codes = [];
    if (!cart) return codes;

    var cartLevel = cart.cart_level_discount_applications || [];
    for (var j = 0; j < cartLevel.length; j++) {
      if (!isRemovableDiscountCodeType(cartLevel[j].type)) continue;
      pushUniqueCode(codes, cartLevel[j].title);
    }

    var items = cart.items || [];
    for (var k = 0; k < items.length; k++) {
      var allocs = items[k].line_level_discount_allocations || [];
      for (var n = 0; n < allocs.length; n++) {
        var app = allocs[n].discount_application || {};
        if (!isRemovableDiscountCodeType(app.type)) continue;
        pushUniqueCode(codes, app.title);
      }
    }
    return codes;
  }

  // 车上是否存在 automatic / script / manual 等非优惠码折扣
  function cartHasNonCodeDiscounts(cart) {
    if (!cart) return false;

    var cartLevel = cart.cart_level_discount_applications || [];
    for (var i = 0; i < cartLevel.length; i++) {
      if (!isRemovableDiscountCodeType(cartLevel[i].type)) return true;
    }

    var items = cart.items || [];
    for (var k = 0; k < items.length; k++) {
      var allocs = items[k].line_level_discount_allocations || [];
      for (var n = 0; n < allocs.length; n++) {
        if (!isRemovableDiscountCodeType((allocs[n].discount_application || {}).type)) {
          return true;
        }
      }
    }
    return false;
  }

  // 校验优惠码是否已真正分摊到当前购物车（update.js 对无效/冲突码常仍返回 200）
  function isDiscountCodeInCart(cart, code) {
    if (!cart || !code) return false;
    var target = code.toString().trim().toLowerCase();
    if (!target) return false;

    var entry = findDiscountCodeEntry(cart, code);
    if (entry && entry.applicable === true) return true;

    var allocated = getAllocatedDiscountCodes(cart);
    for (var i = 0; i < allocated.length; i++) {
      if (allocated[i].toLowerCase() === target) return true;
    }
    return false;
  }

  function normalizeDiscountCode(value) {
    return ((value || '') + '').trim().toLowerCase();
  }

  function discountCodesMatch(a, b) {
    var left = normalizeDiscountCode(a);
    var right = normalizeDiscountCode(b);
    if (!left || !right) return false;
    if (left === right) return true;
    // TEST4 与 TEST4-$5 视为同一码
    if (left.indexOf(right + '-') === 0 || right.indexOf(left + '-') === 0) return true;
    return false;
  }

  function findDiscountCodeEntry(cart, code) {
    if (!cart || !code) return null;
    var list = cart.discount_codes || [];
    for (var i = 0; i < list.length; i++) {
      var apiCode = (list[i].code || list[i].title || '');
      if (discountCodesMatch(code, apiCode)) return list[i];
    }
    return null;
  }

  function getDiscountCodeLabel(cart, code) {
    var entry = findDiscountCodeEntry(cart, code);
    if (entry) {
      return ((entry.code || entry.title || code) + '').trim() || code;
    }
    return code;
  }

  function getDiscountConflictMessage(cart, code) {
    return getDiscountCodeLabel(cart, code) + " couldn't be used with your existing discounts.";
  }

  function getCartCurrency(cart) {
    if (cart && cart.currency) return cart.currency;
    if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    return 'CAD';
  }

  // Shopify 金额为分，GA4 value / discount 用元
  function getCartPayableValue(cart) {
    if (cart && typeof cart.total_price === 'number') return cart.total_price / 100;
    var el =
      document.querySelector('#CartDrawer .totals__total-value') ||
      document.querySelector('.totals__total-value');
    if (!el) return 0;
    var n = parseFloat((el.textContent || '').replace(/[^\d.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  // 取指定优惠码已分摊金额（元）；优先累加行级 allocation，避免与 cart-level 重复计算
  function getDiscountCodeAmount(cart, code) {
    if (!cart || !code) return 0;
    var cents = 0;
    var hasLineMatch = false;

    var items = cart.items || [];
    for (var k = 0; k < items.length; k++) {
      var allocs = items[k].line_level_discount_allocations || [];
      for (var n = 0; n < allocs.length; n++) {
        var app = allocs[n].discount_application || {};
        if (!isRemovableDiscountCodeType(app.type)) continue;
        if (!discountCodesMatch(code, app.title)) continue;
        hasLineMatch = true;
        cents += allocs[n].amount || 0;
      }
    }

    if (!hasLineMatch) {
      var cartLevel = cart.cart_level_discount_applications || [];
      for (var j = 0; j < cartLevel.length; j++) {
        if (!isRemovableDiscountCodeType(cartLevel[j].type)) continue;
        if (!discountCodesMatch(code, cartLevel[j].title)) continue;
        cents += cartLevel[j].total_allocated_amount || 0;
      }
    }

    return cents / 100;
  }

  function pushApplyCouponEvent(params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'apply_coupon',
      event_parameters: {
        button_name: 'Apply_Coupon',
        coupon: params.coupon || '',
        coupon_status: params.coupon_status || 'invalid',
        discount: params.discount || 0,
        currency: params.currency || 'CAD',
        value: typeof params.value === 'number' ? params.value : 0,
      },
    });
  }

  // 单独应用新码判断是否有效；无效码 / 组合冲突返回对应文案与恢复后的 cart
  function resolveDiscountApplyErrorMessage(code, previousCodes, cart) {
    var restoreValue = (previousCodes || []).join(',');
    var hasExistingCodes = previousCodes && previousCodes.length > 0;

    function restorePrevious() {
      return updateCartDiscount(restoreValue);
    }

    function finishWithInvalid() {
      return restorePrevious().then(function (restoredCart) {
        return {
          message: 'Enter a valid discount code or gift card',
          cart: restoredCart,
          coupon_status: 'invalid',
        };
      });
    }

    function finishWithConflict(labelCart) {
      return restorePrevious().then(function (restoredCart) {
        return {
          message: getDiscountConflictMessage(labelCart, code),
          cart: restoredCart,
          coupon_status: 'conflict_not_stackable',
        };
      });
    }

    // 自动折扣等非优惠码折扣已占用时，与 Checkout 一致提示冲突
    if (cartHasNonCodeDiscounts(cart)) {
      var entry = findDiscountCodeEntry(cart, code);
      if (entry && entry.applicable === false) {
        return finishWithConflict(cart);
      }

      return updateCartDiscount(code)
        .then(function (soloCart) {
          if (isDiscountCodeInCart(soloCart, code)) {
            return finishWithConflict(soloCart);
          }
          if (findDiscountCodeEntry(soloCart, code) || findDiscountCodeEntry(cart, code)) {
            return finishWithConflict(soloCart);
          }
          return finishWithInvalid();
        });
    }

    if (!hasExistingCodes) {
      return finishWithInvalid();
    }

    return updateCartDiscount(code)
      .then(function (soloCart) {
        if (isDiscountCodeInCart(soloCart, code)) {
          return finishWithConflict(soloCart);
        }
        return finishWithInvalid();
      });
  }

  // 从橙色胶囊 DOM 读取当前可带到 checkout 的优惠码
  function getAppliedDiscountCodes(root) {
    var codes = [];
    var scope = root || document.querySelector('#CartDrawer .cart-discount');
    if (!scope) return codes;

    scope.querySelectorAll('.cart-discount__tag-remove').forEach(function (btn) {
      var type = (btn.getAttribute('data-discount-type') || '').toLowerCase();
      var title = (btn.getAttribute('data-discount-title') || '').trim();
      if (!title) return;
      // 自动折扣/脚本折扣的 title 不是可兑换码，不能拼进 checkout URL
      if (type === 'automatic' || type === 'script' || type === 'manual') return;
      if (codes.indexOf(title) === -1) codes.push(title);
    });
    return codes;
  }

  function getCheckoutDiscountCodes() {
    return getAppliedDiscountCodes();
  }

  function getDiscountMessageTone(message) {
    if (!message) return '';
    var text = (message + '').toLowerCase();
    if (text === 'this discount code is already applied') return 'warning';
    if (text.indexOf("couldn't be used with your existing discounts") !== -1) return 'warning';
    if (text === 'enter a valid discount code or gift card') return 'error';
    return 'error';
  }

  function showDiscountMessage(root, message) {
    if (!root) return;
    var msg = root.querySelector('.cart-discount__message');
    var input = root.querySelector('.cart-discount__input');
    if (!msg) return;

    msg.classList.remove('cart-discount__message--warning', 'cart-discount__message--error');
    if (input) input.classList.remove('cart-discount__input--warning', 'cart-discount__input--error');

    if (message) {
      var tone = getDiscountMessageTone(message);
      if (tone) {
        msg.classList.add('cart-discount__message--' + tone);
        if (input) input.classList.add('cart-discount__input--' + tone);
      }
      msg.textContent = message;
      msg.hidden = false;
    } else {
      msg.textContent = '';
      msg.hidden = true;
    }
    sizeCartDrawerFooter();
  }

  // 抽屉 rebuild 后恢复错误提示
  function restoreDiscountErrorMessage() {
    if (!pendingDiscountError) return;
    var err = pendingDiscountError;
    pendingDiscountError = '';
    var root = document.querySelector('#CartDrawer .cart-discount');
    if (!root) return;
    root.classList.add('is-open');
    var header = root.querySelector('.cart-discount__header');
    if (header) header.setAttribute('aria-expanded', 'true');
    showDiscountMessage(root, err);
  }

  document.addEventListener('click', function (event) {
    // ----- 折叠展开：先静默测量起止高度，再同步过渡 footer / 内容区 -----
    var header = event.target.closest('.cart-discount__header');
    if (header) {
      var root = header.closest('.cart-discount');
      var collapse = root && root.querySelector('.cart-discount__collapse');
      var footer = root && root.closest('.drawer__footer');
      if (!root || !collapse || !footer || root.classList.contains('is-animating')) return;

      var open = !root.classList.contains('is-open');
      var startH = footer.offsetHeight;

      header.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.add('is-animating');

      // 展开时埋点
      if (open) {
        window.VWO = window.VWO || [];
        VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
        VWO.event('cartDiscountShow')

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'select_content',
          event_parameters: {
            content_type: 'Cart',
            content_name: 'Discount_Code',
            button_name: 'Discount_Code',
          },
        });
      }

      // 关闭过渡，瞬时切到目标态以测量最终 footer 高度（同帧内复位，避免闪烁）
      collapse.style.transition = 'none';
      footer.style.transition = 'none';

      root.classList.toggle('is-open', open);
      collapse.style.gridTemplateRows = open ? '1fr' : '0fr';
      footer.style.height = 'auto';
      void footer.offsetHeight;
      var endH = footer.offsetHeight;

      // 回到起始高度，再开启动画
      root.classList.toggle('is-open', !open);
      collapse.style.gridTemplateRows = open ? '0fr' : '1fr';
      footer.style.height = startH + 'px';
      void footer.offsetHeight;

      collapse.style.transition = 'grid-template-rows ' + DURATION + 'ms ease';
      footer.style.transition = 'height ' + DURATION + 'ms ease';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.toggle('is-open', open);
          collapse.style.gridTemplateRows = '';
          footer.style.height = endH + 'px';
        });
      });

      setTimeout(function () {
        collapse.style.transition = '';
        footer.style.transition = '';
        root.classList.remove('is-animating');
        sizeCartDrawerFooter();
      }, DURATION + 20);
      return;
    }

    // ----- Apply 优惠码 -----
    var applyBtn = event.target.closest('.cart-discount__apply');
    if (applyBtn) {
      var applyRoot = applyBtn.closest('.cart-discount');
      var input = applyRoot && applyRoot.querySelector('.cart-discount__input');
      var code = ((input && input.value) || '').trim();
      if (!code) {
        showDiscountMessage(applyRoot, 'Please enter a discount code');
        if (input) input.focus();
        return;
      }

      showDiscountMessage(applyRoot, '');
      var previousCodes = getAppliedDiscountCodes(applyRoot);
      var codes = previousCodes.slice();
      var alreadyApplied = previousCodes.some(function (c) {
        return discountCodesMatch(c, code);
      });
      if (alreadyApplied) {
        showDiscountMessage(applyRoot, 'This discount code is already applied');
        pushApplyCouponEvent({
          coupon: code,
          coupon_status: 'duplicated',
          discount: 0,
          currency: getCartCurrency(null),
          value: getCartPayableValue(null),
        });
        return;
      }
      codes.push(code);

      // 多个码用逗号拼接；返回后必须校验新码是否真的分摊到金额
      setCheckoutLoading(true);
      setDiscountActionLoading(applyBtn, true);
      updateCartDiscount(codes.join(','))
        .then(function (cart) {
          if (isDiscountCodeInCart(cart, code)) {
            pushApplyCouponEvent({
              coupon: getDiscountCodeLabel(cart, code) || code,
              coupon_status: 'success',
              discount: getDiscountCodeAmount(cart, code),
              currency: getCartCurrency(cart),
              value: getCartPayableValue(cart),
            });
            return refreshCartDrawer();
          }

          // 无效/未分摊码：恢复之前的有效码，并提示红字错误
          return resolveDiscountApplyErrorMessage(code, previousCodes, cart)
            .then(function (result) {
              pendingDiscountError = result.message;
              pushApplyCouponEvent({
                coupon: code,
                coupon_status: result.coupon_status || 'invalid',
                discount: 0,
                currency: getCartCurrency(result.cart),
                value: getCartPayableValue(result.cart),
              });
              return refreshCartDrawer();
            });
        })
        .catch(function (err) {
          var description =
            (err && err.responseJSON && (err.responseJSON.description || err.responseJSON.message)) ||
            err.message ||
            'Could not apply this discount code';
          pushApplyCouponEvent({
            coupon: code,
            coupon_status: 'invalid',
            discount: 0,
            currency: getCartCurrency(null),
            value: getCartPayableValue(null),
          });
          showDiscountMessage(applyRoot, description);
          if (input) input.focus();
        })
        .finally(function () {
          setDiscountActionLoading(applyBtn, false);
          setCheckoutLoading(false);
        });
      return;
    }

    // ----- 移除单个优惠码胶囊 -----
    var removeBtn = event.target.closest('.cart-discount__tag-remove');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();

      var removeRoot = removeBtn.closest('.cart-discount');
      var removeTitle = (removeBtn.getAttribute('data-discount-title') || '').trim();
      var removeType = (removeBtn.getAttribute('data-discount-type') || '').toLowerCase();
      var nextDiscount = '';

      if (removeType !== 'automatic' && removeType !== 'script' && removeType !== 'manual') {
        var nextCodes = getAppliedDiscountCodes(removeRoot).filter(function (c) {
          return c.toLowerCase() !== removeTitle.toLowerCase();
        });
        nextDiscount = nextCodes.join(',');
      } else {
        // 非 discount_code 类型：由 update 传空串处理
      }

      showDiscountMessage(removeRoot, '');
      setCheckoutLoading(true);
      setDiscountActionLoading(removeBtn, true);
      updateCartDiscount(nextDiscount)
        .then(function (cart) {
          // 用移除折扣后的应付金额上报
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event_parameters: null });
          window.dataLayer.push({
            event: 'ga4Event',
            event_name: 'remove_coupon',
            event_parameters: {
              button_name: 'Remove_Coupon',
              coupon: removeTitle,
              currency: getCartCurrency(cart),
              value: getCartPayableValue(cart),
            },
          });
          return refreshCartDrawer();
        })
        .catch(function (err) {
          var description =
            (err && err.responseJSON && (err.responseJSON.description || err.responseJSON.message)) ||
            err.message ||
            'Could not remove this discount code';
          showDiscountMessage(removeRoot, description);
        })
        .finally(function () {
          setDiscountActionLoading(removeBtn, false);
          setCheckoutLoading(false);
        });
    }
  });

  // 输入时清除错误态
  document.addEventListener('input', function (event) {
    var inputEl = event.target.closest('.cart-discount__input');
    if (!inputEl) return;
    showDiscountMessage(inputEl.closest('.cart-discount'), '');
  });

  // 回车等同 Apply
  document.addEventListener('keydown', function (event) {
    var inputEl = event.target.closest('.cart-discount__input');
    if (!inputEl) return;
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      var apply = inputEl.closest('.cart-discount').querySelector('.cart-discount__apply');
      if (apply) apply.click();
    }
  });

  // ----- Checkout：拦截表单提交，把优惠码带到结账页 -----
  // 直接 POST /cart 进 checkout 时，update.js 写入的折扣有时会丢失
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#CartDrawer-Form');
    if (!form) return;

    window.VWO = window.VWO || [];
    VWO.event = VWO.event || function () {VWO.push(['event'].concat([].slice.call(arguments)))};
    VWO.event('cartCheckout')

    var codes = getCheckoutDiscountCodes();
    if (!codes.length) return;

    event.preventDefault();
    window.location.href = '/checkout?discount=' + encodeURIComponent(codes.join(',')); 
  });
})();
